import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRevenueRepFilter } from "../Filter";
import { Fetch, ILazyParams } from "../../../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { ProjectRevenueDetails } from "./ProjectRevenueDetails";
import { Rating } from "./Rating";
import { ILogin } from "../../../../models/Login";

interface IProps {
    toast: any
}

interface ISalesHeadRevenueReport {
    login_ID?: number,
    user_Employee_ID?: string,
    user_Name?: string,
    branchName?: string,
    company_Name?: string,
    monthly_CTC?: number,
    seating_Cost?: number,
    incentive?: number,
    noOfECI?: number,
    noOfPO?: number,
    sales_Monthly_CTC?: number,
    sales_Seating_Cost?: number,
    sales_Incentive?: number,
    sales_Revenues?: number,
    sales_Rev_P_L?: number,
    projected_Sales_Revenues?: number,
    projected_Sales_Incentive?: number,
    projected_Sales_Monthly_CTC?: number,
    projected_Sales_Seating_Cost?: number,
    sales_Proj_Rev_P_L?: number,
    total: number,
}

export const Table = (props: IProps) => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISalesHeadRevenueReport>, loading: boolean });
    const [revenueFilter, setRevenueFilter] = useState<IRevenueRepFilter>(EmptyRecRepFilter);
    const [openProjectRevenueDetails, setOpenProjectRevenueDetails] = useState({ open: false, user_Employee_ID: '' } as { open: boolean, user_Employee_ID: string });

    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const header = () => <p>Revenue Report</p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Revenue/getSalesHeadRevenueReport", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(revenueFilter)}`, props.toast);
        if (response) {
            const data: Array<ISalesHeadRevenueReport> = await response.json();
            if (data.length > 0) setTotalRecords(data[0].total || 0);
            else setTotalRecords(0);
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    // const projectRevenue = (rowData: IRecruiterHeadRevenueReport) => {
    //     return <p onClick={() => {
    //         if (rowData.projected_Revenue && rowData.projected_Revenue > 0) {
    //             setOpenProjectRevenueDetails({ open: true, user_Employee_ID: (rowData.user_Employee_ID || '') });
    //         } else props.toast.current.show({ severity: 'info', detail: 'No Projected Revenue Details To Show', life: 3000 });
    //     }} className="cursor-pointer text-cyan-700 underline">₹ {parseInt(`${rowData.projected_Revenue}`)}</p>;
    // }

    // const projectRevenuePL = (rowData: IRecruiterHeadRevenueReport) => {
    //     return <p style={{ color: ((rowData.projected_Revenue || 0) < ((rowData.project_Rev_PL_Amnt || 0) + (rowData.approxProjRevM_Salary || 0) + (rowData.approxProjSeating_Cost || 0))) ? "red" : "green" }}>₹ {parseInt(`${(rowData.projected_Revenue || 0) - ((rowData.project_Rev_PL_Amnt || 0) + (rowData.approxProjRevM_Salary || 0) + (rowData.approxProjSeating_Cost || 0))}`)}</p>;
    // }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="my-2">
                    <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
                </div>
            </>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                {(_roles.includes(1) || _roles.includes(12)) && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
            </>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [lazyParams, revenueFilter]);

    // ₹

    return (
        <>
            <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3" />
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter revenueFilter={revenueFilter} setRevenueFilter={setRevenueFilter} showNormalUsers={false} showRecHeadUsers={false} showSalesHeadUsers={true} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                lazy dataKey="login_ID" responsiveLayout="scroll"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Employee_ID" header="Employee ID" />
                <Column field="user_Name" header="Name" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="monthly_CTC" header="Monthly CTC" />
                <Column field="seating_Cost" header="Seating Cost" />
                <Column field="incentive" header="Incentive" />
                <Column field="noOfECI" header="ECI" />
                <Column field="noOfPO" header="PO" />
                <Column field="sales_Monthly_CTC" header="Sales Monthly CTC" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.sales_Monthly_CTC}`)}</p>} />
                <Column field="sales_Seating_Cost" header="Sales Seating Cost" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.sales_Seating_Cost}`)}</p>} />
                <Column field="sales_Incentive" header="Sales Incentive" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.sales_Incentive}`)}</p>} />
                <Column field="sales_Revenues" header="Sales Revenues" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.sales_Revenues}`)}</p>} />
                <Column field="sales_Rev_P_L" header="Sales R.Profit/Loss" body={(rowData: ISalesHeadRevenueReport) => <p style={{ color: ((rowData.sales_Rev_P_L || 0) >= 0) ? "green" : "red" }}>₹ {parseInt(`${rowData.sales_Rev_P_L}`)}</p>} />
                <Column field="projected_Sales_Revenues" header="Projected sales Revenues" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Sales_Revenues}`)}</p>} />
                <Column field="projected_Sales_Incentive" header="Projected sales Incentive" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Sales_Incentive}`)}</p>} />
                <Column field="projected_Sales_Monthly_CTC" header="Projected sales Monthly CTC" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Sales_Monthly_CTC}`)}</p>} />
                <Column field="projected_Sales_Seating_Cost" header="Projected sales Seating Cost" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Sales_Seating_Cost}`)}</p>} />
                <Column field="sales_Proj_Rev_P_L" header="Sales Proj Rev P/L" body={(rowData: ISalesHeadRevenueReport) => <p>₹ {parseInt(`${rowData.sales_Proj_Rev_P_L}`)}</p>} />
                <Column field="rating" header="Rating" headerStyle={{ minWidth: "12rem" }} bodyStyle={{ minWidth: "12rem" }} body={(rowData: ISalesHeadRevenueReport) => <Rating rev={(rowData.sales_Revenues || 0)} exp={((rowData.sales_Monthly_CTC || 0) + (rowData.sales_Seating_Cost || 0) + (rowData.sales_Incentive || 0))} />} />
                {/* <Column field="monthly_CTC" header="Monthly CTC" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.monthly_CTC}`)}</p>} /> */}
                {/* <Column field="" header="R P/L" body={(rowData: IRecruiterHeadRevenueReport) => <p style={{ color: ((rowData.expenses || 0) < (rowData.revenue || 0)) ? "green" : "red" }}>₹ {(((rowData.revenue || 0) < (rowData.expenses || 0))) ? parseInt(`${(-1 * ((rowData.revenue || 0) - (rowData.expenses || 0)))}`) : parseInt(`${((rowData.revenue || 0) - (rowData.expenses || 0))}`)}</p>} /> */}

                {/* <Column field="projected_Revenue" header="P.Revenue" body={projectRevenue} />
                <Column field="" header="P.R P/L" body={projectRevenuePL} /> */}
                <Column field="" header="Action" />
            </DataTable>
            {/* <ProjectRevenueDetails open={openProjectRevenueDetails.open} hideDialog={() => setOpenProjectRevenueDetails({ open: false, user_Employee_ID: '' })} user_Employee_ID={openProjectRevenueDetails.user_Employee_ID} revenueFilter={revenueFilter} toast={props.toast} /> */}
        </>
    );
}